/* =============================================================
   ECOBOS CART - V2
   ============================================================= */

(function() {

  'use strict';


  const ECOBOS_CART_KEY =
    'ecobos_cart_v1';


  /* =========================================================
     GELD
     ========================================================= */

  function roundMoney(
    value
  ) {

    return (
      Math.round(
        (
          Number(value) +
          Number.EPSILON
        ) * 100
      ) / 100
    );

  }


  function money(
    value
  ) {

    return new Intl.NumberFormat(
      'nl-BE',
      {
        style:
          'currency',

        currency:
          'EUR',

        minimumFractionDigits:
          2,

        maximumFractionDigits:
          2
      }
    ).format(
      roundMoney(value)
    );

  }



  /* =========================================================
     CART LEZEN / OPSLAAN
     ========================================================= */

  function getCart() {

    try {

      const stored =
        localStorage.getItem(
          ECOBOS_CART_KEY
        );


      if (!stored) {

        return {
          version: 1,
          items: []
        };

      }


      const cart =
        JSON.parse(
          stored
        );


      if (
        !cart ||
        !Array.isArray(
          cart.items
        )
      ) {

        return {
          version: 1,
          items: []
        };

      }


      return cart;

    }

    catch(error) {

      console.error(
        'ECOBOS cart kon niet worden gelezen:',
        error
      );


      return {
        version: 1,
        items: []
      };

    }

  }


  function saveCart(
    cart
  ) {

    localStorage.setItem(
      ECOBOS_CART_KEY,
      JSON.stringify(
        cart
      )
    );


    window.dispatchEvent(
      new CustomEvent(
        'ecobos:cart:updated',
        {
          detail:
            cart
        }
      )
    );

  }



  /* =========================================================
     HTML VEILIG MAKEN
     ========================================================= */

  function escapeHtml(
    value
  ) {

    return String(
      value ?? ''
    )
      .replace(
        /&/g,
        '&amp;'
      )
      .replace(
        /</g,
        '&lt;'
      )
      .replace(
        />/g,
        '&gt;'
      )
      .replace(
        /"/g,
        '&quot;'
      )
      .replace(
        /'/g,
        '&#039;'
      );

  }



  /* =========================================================
     PRIJSHELPERS
     ========================================================= */

  function getPriceSeriesPrice(
    priceSeries,
    quantity
  ) {

    if (
      !priceSeries ||
      !Array.isArray(
        priceSeries.quantities
      ) ||
      !priceSeries.quantities.length ||
      !Array.isArray(
        priceSeries.prices
      ) ||
      !priceSeries.prices.length
    ) {

      return null;

    }


    let selectedPrice =
      null;


    priceSeries.quantities.forEach(
      function(tierQuantity, index) {

        if (
          quantity >=
          Number(tierQuantity)
        ) {

          /*
          * Fill-forward:
          * als voor deze staffel geen nieuwe
          * prijs bestaat, blijft de laatst
          * ingevulde prijs geldig.
          */

          if (
            priceSeries.prices[
              index
            ] !== undefined &&
            priceSeries.prices[
              index
            ] !== null &&
            priceSeries.prices[
              index
            ] !== ''
          ) {

            selectedPrice =
              Number(
                priceSeries.prices[
                  index
                ]
              );

          }

        }

      }
    );


    return selectedPrice;

  }

  function getItemPrice(
    item,
    quantity
  ) {

    if (
      !item ||
      !item.priceSeries
    ) {
      return 0;
    }


    const price =
      getPriceSeriesPrice(
        item.priceSeries,
        quantity
      );


    return (
      price !== null
        ? price
        : 0
    );

  }


  function getChoice(
    option,
    choiceId
  ) {

    if (
      !option ||
      !Array.isArray(
        option.choices
      )
    ) {

      return null;

    }


    return (
      option.choices.find(
        function(choice) {

          return (
            choice.id ===
            choiceId
          );

        }
      ) ||
      null
    );

  }



  /* =========================================================
     CART ITEM PRIJS HERBEREKENEN
     ========================================================= */

  function calculateCartItemPrice(
  item,
  quantity
) {

  const config =
    item.pricingConfig;


  const savedState =
    item.state;


  /*
   * Oude cart-items zonder
   * pricingConfig.
   *
   * Eventuele oude setupFees
   * worden bewust genegeerd.
   */
  if (
    !config ||
    !savedState ||
    !savedState.options
  ) {

    return {
      unitPrice: 0,
      productsTotal: 0,
      setupFees: 0,
      total: 0
    };

  }


  let unitPrice =
    getItemPrice(
      config.basePrice,
      quantity
    );


  config.options.forEach(
    function(option) {

      const optionState =
        savedState.options[
          option.id
        ];


      if (!optionState) {
        return;
      }


      /* =====================================
         PERSONALISATIE
         ===================================== */

      if (
        option.type ===
        'personalisation'
      ) {

        if (
          optionState.noPersonalisation
        ) {
          return;
        }


        option.positions.forEach(
          function(position) {

            const positionState =
              optionState.positions &&
              optionState.positions[
                position.id
              ];


            if (
              !positionState ||
              !positionState.enabled ||
              !positionState.method
            ) {
              return;
            }


            const method =
              option.methods[
                positionState.method
              ];


            if (!method) {
              return;
            }


            unitPrice +=
              getItemPrice(
                method,
                quantity
              );

          }
        );

      }


      /* =====================================
         SINGLE CHOICE
         ===================================== */

      else if (
        option.type ===
        'single_choice'
      ) {

        if (
          !optionState.choice
        ) {
          return;
        }


        const choice =
          getChoice(
            option,
            optionState.choice
          );


        if (!choice) {
          return;
        }


        unitPrice +=
          getItemPrice(
            choice,
            quantity
          );

      }

    }
  );


  unitPrice =
    roundMoney(
      unitPrice
    );


  const productsTotal =
    roundMoney(
      unitPrice *
      quantity
    );


  return {

    unitPrice,

    productsTotal,

    setupFees:
      0,

    total:
      productsTotal

  };

}



  /* =========================================================
     CONFIGURATIE TONEN
     ========================================================= */

  function getConfigurationHtml(
    item
  ) {

    if (
      !Array.isArray(
        item.configuration
      )
    ) {

      return '';

    }


    let html =
      '';


    item.configuration.forEach(
      function(option) {

        /*
         * PERSONALISATIE
         */
        if (
          option.type ===
          'personalisation'
        ) {

          if (
            option.noPersonalisation
          ) {

            html +=
              '<div class="ecobos-cart-item__option">' +

                '<span>' +
                  escapeHtml(
                    option.optionLabel
                  ) +
                '</span>' +

                '<strong>' +
                  'Geen personalisatie' +
                '</strong>' +

              '</div>';


            return;

          }


          if (
            Array.isArray(
              option.positions
            )
          ) {

            option.positions.forEach(
              function(position) {

                html +=
                  '<div class="ecobos-cart-item__option">' +

                    '<span>' +
                      escapeHtml(
                        position.positionLabel
                      ) +
                    '</span>' +

                    '<strong>' +
                      escapeHtml(
                        position.methodLabel
                      ) +
                    '</strong>' +

                  '</div>';

              }
            );

          }

        }


        /*
         * SINGLE CHOICE
         */
        else if (
          option.type ===
          'single_choice'
        ) {

          html +=
            '<div class="ecobos-cart-item__option">' +

              '<span>' +
                escapeHtml(
                  option.optionLabel
                ) +
              '</span>' +

              '<strong>' +
                escapeHtml(
                  option.choiceLabel
                ) +
              '</strong>' +

            '</div>';

        }

        /*
        * QUANTITY DISTRIBUTION
        */
        else if (
          option.type ===
          'quantity_distribution'
        ) {

          if (
            !Array.isArray(
              option.values
            ) ||
            !option.values.length
          ) {
            return;
          }


          const distributionText =
            option.values
              .map(
                function(value) {

                  return (
                    '<label class="ecobos-cart-distribution__row">' +

                      '<span>' +
                        escapeHtml(
                          value.valueLabel
                        ) +
                      '</span>' +

                      '<input ' +
                        'type="number" ' +
                        'min="0" ' +
                        'step="1" ' +
                        'value="' +
                          escapeHtml(
                            value.quantity
                          ) +
                        '" ' +
                        'data-cart-distribution="' +
                          escapeHtml(
                            item.id
                          ) +
                        '" ' +
                        'data-cart-distribution-option="' +
                          escapeHtml(
                            option.optionId
                          ) +
                        '" ' +
                        'data-cart-distribution-value="' +
                          escapeHtml(
                            value.valueId
                          ) +
                        '"' +
                      '>' +

                    '</label>'
                  );

                }
              )
              .join('');


          html +=
            '<div class="ecobos-cart-item__option">' +

              '<span>' +
                escapeHtml(
                  option.optionLabel
                ) +
              '</span>' +

              '<strong>' +
                distributionText +
              '</strong>' +

            '</div>';

        }

      }
    );


    return html;

  }



  /* =========================================================
     EDIT URL
     ========================================================= */

  function getEditUrl(
    item
  ) {

    const url =
      new URL(
        item.productUrl || '/',
        window.location.origin
      );


    url.searchParams.set(
      'ecobos_edit',
      item.id
    );


    url.searchParams.set(
      'ecobos_return',
      window.location.pathname +
      window.location.search
    );


    return (
      url.pathname +
      url.search +
      url.hash
    );

  }



  /* =========================================================
     CART INITIALISEREN
     ========================================================= */

  function initEcobosCart(
    root
  ) {

    if (!root) {
      return;
    }


    const itemsContainer =
      root.querySelector(
        '[data-cart-items]'
      );


    const emptyState =
      root.querySelector(
        '[data-cart-empty]'
      );


    const content =
      root.querySelector(
        '[data-cart-content]'
      );


    const subtotalElement =
      root.querySelector(
        '[data-cart-subtotal]'
      );


    const checkoutButton =
      root.querySelector(
        '[data-cart-checkout]'
      );


    const checkoutMessage =
      root.querySelector(
        '[data-cart-checkout-message]'
      );



    /* =======================================================
       SUBTOTAAL
       ======================================================= */

    function calculateSubtotal(
  cart
) {

  let subtotal =
    0;


  cart.items.forEach(
    function(item) {

      const quantity =
        Number(
          item.quantity || 0
        );


      const pricing =
        calculateCartItemPrice(
          item,
          quantity
        );


      subtotal +=
        pricing.total;

    }
  );


  return roundMoney(
    subtotal
  );

}



    /* =======================================================
       RENDER CART
       ======================================================= */

    function renderCart() {

  const cart =
    getCart();


  if (
    cart.items.length === 0
  ) {

    /*
     * Oude productweergave leegmaken.
     */

    itemsContainer.innerHTML =
      '';


    /*
     * Lege winkelmand tonen.
     */

    emptyState.hidden =
      false;


    /*
     * Normale winkelmandinhoud verbergen.
     */

    content.hidden =
      true;


    /*
     * Subtotaal resetten.
     */

    subtotalElement.textContent =
      money(0);


    return;

  }


  /*
   * Er zitten producten in de winkelmand.
   */

  emptyState.hidden =
    true;


  content.hidden =
    false;


  /*
   * Eerst bestaande HTML leegmaken
   * en daarna opnieuw opbouwen.
   */

  itemsContainer.innerHTML =
    '';


  cart.items.forEach(
        function(item) {

          const article =
            document.createElement(
              'article'
            );


          article.className =
            'ecobos-cart-item';


          const quantity =
            Number(
              item.quantity || 0
            );


          const pricing =
            calculateCartItemPrice(
              item,
              quantity
            );


          const unitPrice =
            pricing.unitPrice;


          const total =
            pricing.total;


          const editUrl =
            getEditUrl(
              item
            );

          const hasQuantityDistribution =
            Array.isArray(
              item.configuration
            ) &&
            item.configuration.some(
              function(option) {

                return (
                  option.type ===
                  'quantity_distribution'
                );

              }
            );

          article.innerHTML =

            '<div class="ecobos-cart-item__layout">' +


              (
                item.productImage

                  ?

                    '<div class="ecobos-cart-item__image">' +

                      '<a href="' +
                        escapeHtml(
                          item.productUrl || '#'
                        ) +
                      '">' +

                        '<img ' +
                          'src="' +
                            escapeHtml(
                              item.productImage
                            ) +
                          '" ' +
                          'alt="' +
                            escapeHtml(
                              item.productName ||
                              'Product'
                            ) +
                          '">' +

                      '</a>' +

                    '</div>'

                  :

                    ''
              ) +


              '<div class="ecobos-cart-item__main">' +


                '<div class="ecobos-cart-item__top">' +


                  '<div>' +


                    '<h2 class="ecobos-cart-item__title">' +

                      '<a href="' +
                        escapeHtml(
                          item.productUrl || '#'
                        ) +
                      '">' +

                        escapeHtml(
                          item.productName ||
                          'Product'
                        ) +

                      '</a>' +

                    '</h2>' +


                    '<div class="ecobos-cart-item__configuration">' +

                      getConfigurationHtml(
                        item
                      ) +

                    '</div>' +


                    '<a ' +
                      'href="' +
                        escapeHtml(
                          editUrl
                        ) +
                      '" ' +
                      'class="ecobos-cart-item__edit"' +
                    '>' +

                      'Configuratie wijzigen' +

                    '</a>' +


                  '</div>' +


                  '<button ' +
                    'type="button" ' +
                    'class="ecobos-cart-item__remove" ' +
                    'data-cart-remove="' +
                      escapeHtml(
                        item.id
                      ) +
                    '"' +
                  '>' +

                    'Verwijderen' +

                  '</button>' +


                '</div>' +


                '<div class="ecobos-cart-item__pricing">' +


                  '<div class="ecobos-cart-item__quantity">' +

                    '<label>' +

                      'Aantal' +

                      (
                        hasQuantityDistribution

                          ?

                            '<strong>' +
                              quantity +
                            '</strong>'

                          :

                            '<input ' +
                              'type="number" ' +
                              'min="1" ' +
                              'step="1" ' +
                              'value="' +
                                quantity +
                              '" ' +
                              'data-cart-quantity="' +
                                escapeHtml(
                                  item.id
                                ) +
                              '"' +
                            '>'

                      ) +

                    '</label>' +

                  '</div>' +


                  '<div class="ecobos-cart-item__unit-price">' +
                    '<span>' +
                      'Stukprijs' +
                    '</span>' +

                    '<strong>' +
                      money(
                        unitPrice
                      ) +
                    '</strong>' +

                  '</div>' +


                  '<div class="ecobos-cart-item__setup-fee">' +

                    '<span>' +
                      'Opstartkosten' +
                    '</span>' +

                    '<strong>' +
                      'GRATIS' +
                    '</strong>' +

                  '</div>' +


                  '<div class="ecobos-cart-item__line-total">' +

                    '<span>' +
                      'Totaal' +
                    '</span>' +

                    '<strong>' +
                      money(
                        total
                      ) +
                    '</strong>' +

                  '</div>' +


                '</div>' +


              '</div>' +


            '</div>';


          itemsContainer.appendChild(
            article
          );

        }
      );


      subtotalElement.textContent =
        money(
          calculateSubtotal(
            cart
          )
        );

    }



    /* =======================================================
       ITEM VERWIJDEREN
       ======================================================= */

    function removeItem(
      itemId
    ) {

      const cart =
        getCart();


      cart.items =
        cart.items.filter(
          function(item) {

            return (
              item.id !==
              itemId
            );

          }
        );


      saveCart(
        cart
      );


      renderCart();

    }

    /* =======================================================
      VERDEELD AANTAL WIJZIGEN
      ======================================================= */

    function updateDistributionQuantity(
      itemId,
      optionId,
      valueId,
      quantity
    ) {

      quantity =
        parseInt(
          quantity,
          10
        );


      if (
        Number.isNaN(quantity) ||
        quantity < 0
      ) {
        return;
      }


      const cart =
        getCart();


      const item =
        cart.items.find(
          function(cartItem) {

            return (
              cartItem.id ===
              itemId
            );

          }
        );


      if (!item) {
        return;
      }


      const configurationOption =
        (
          item.configuration || []
        ).find(
          function(option) {

            return (
              option.optionId ===
                optionId &&
              option.type ===
                'quantity_distribution'
            );

          }
        );


      if (
        !configurationOption ||
        !Array.isArray(
          configurationOption.values
        )
      ) {
        return;
      }


      const configurationValue =
        configurationOption.values.find(
          function(value) {

            return (
              value.valueId ===
              valueId
            );

          }
        );


      if (!configurationValue) {
        return;
      }


      /*
      * Nieuw aantal opslaan in de
      * leesbare configuratie.
      */

      configurationValue.quantity =
        quantity;


      /*
      * Dezelfde wijziging ook in state
      * bewaren. Zo blijft "Configuratie
      * wijzigen" correct werken.
      */

      const optionState =
        item.state &&
        item.state.options &&
        item.state.options[
          optionId
        ];


      if (
        optionState &&
        optionState.distribution
      ) {

        optionState.distribution[
          valueId
        ] =
          quantity;

      }


      /*
      * Nieuw totaal bepalen uit alle
      * verdeelde waarden.
      */

      const totalQuantity =
        configurationOption.values.reduce(
          function(total, value) {

            return (
              total +
              Number(
                value.quantity || 0
              )
            );

          },
          0
        );


      /*
      * Een bestelling van totaal 0
      * willen we niet opslaan.
      */

      if (
        totalQuantity < 1
      ) {
        return;
      }


      item.quantity =
        totalQuantity;


      /*
      * Ook distributionContext bijwerken.
      * Daardoor ziet de configurator deze
      * verdeling later als behorend bij
      * het nieuwe totale aantal.
      */

      if (
        optionState &&
        optionState.distributionContext
      ) {

        optionState.distributionContext.quantity =
          totalQuantity;

      }


      if (optionState) {

        optionState.manuallyAdjusted =
          true;

      }


      /*
      * Prijs opnieuw berekenen aan de hand
      * van het nieuwe totale aantal.
      */

      const pricing =
        calculateCartItemPrice(
          item,
          totalQuantity
        );


      item.unitPrice =
        pricing.unitPrice;


      item.productsTotal =
        pricing.productsTotal;


      item.setupFees =
        pricing.setupFees;


      item.total =
        pricing.total;


      item.updatedAt =
        new Date().toISOString();


      saveCart(
        cart
      );


      renderCart();

    }

    /* =======================================================
       AANTAL WIJZIGEN
       ======================================================= */

    function updateQuantity(
      itemId,
      quantity
    ) {

      quantity =
        parseInt(
          quantity,
          10
        );


      if (
        !quantity ||
        quantity < 1
      ) {

        return;

      }


      const cart =
        getCart();


      const item =
        cart.items.find(
          function(cartItem) {

            return (
              cartItem.id ===
              itemId
            );

          }
        );


      if (!item) {
        return;
      }


      const pricing =
        calculateCartItemPrice(
          item,
          quantity
        );


      item.quantity =
        quantity;


      item.unitPrice =
        pricing.unitPrice;


      item.productsTotal =
        pricing.productsTotal;


      item.setupFees =
        pricing.setupFees;


      item.total =
        pricing.total;


      item.updatedAt =
        new Date().toISOString();


      saveCart(
        cart
      );


      renderCart();

    }



    /* =======================================================
       CLICK EVENTS
       ======================================================= */

    root.addEventListener(
      'click',
      async function(event) {

        const removeButton =
          event.target.closest(
            '[data-cart-remove]'
          );


        if (
          removeButton
        ) {

          event.preventDefault();


          removeItem(
            removeButton.dataset.cartRemove
          );


          return;

        }


        const checkoutTrigger =
          event.target.closest(
            '[data-cart-checkout]'
          );


        if (
          checkoutTrigger
        ) {

          event.preventDefault();


          const cart =
            getCart();


          if (
            !cart.items.length
          ) {

            checkoutMessage.hidden =
              false;

            checkoutMessage.textContent =
              'Je winkelmandje is leeg.';

            return;

          }


          checkoutTrigger.disabled =
            true;


          const originalButtonText =
            checkoutTrigger.textContent;


          checkoutTrigger.textContent =
            'Even geduld...';


          checkoutMessage.hidden =
            true;


          try {

            const response =
              await fetch(
                'https://ecobos-shopify-configurator-checkou.vercel.app/api/create-checkout',
                {
                  method:
                    'POST',

                  headers: {
                    'Content-Type':
                      'application/json'
                  },

                  body:
                    JSON.stringify(
                      cart
                    )
                }
              );


            const data =
              await response.json();


            if (
              !response.ok ||
              !data.success
            ) {

              throw new Error(
                data.error ||
                'Checkout kon niet worden aangemaakt.'
              );

            }


            if (
              !data.checkoutUrl
            ) {

              throw new Error(
                'Shopify gaf geen checkout-link terug.'
              );

            }


            window.location.href =
              data.checkoutUrl;

          }

          catch(error) {

            console.error(
              'Ecobos checkout fout:',
              error
            );


            checkoutMessage.hidden =
              false;


            checkoutMessage.textContent =
              error.message ||
              'Er ging iets mis bij het starten van de checkout.';


            checkoutTrigger.disabled =
              false;


            checkoutTrigger.textContent =
              originalButtonText;

          }


          return;

        }

      }
    );



    /* =======================================================
       CHANGE EVENTS
       ======================================================= */

    root.addEventListener(
      'change',
      function(event) {

        const quantityInput =
          event.target.closest(
            '[data-cart-quantity]'
          );


        if (
          quantityInput
        ) {

          updateQuantity(
            quantityInput.dataset.cartQuantity,
            quantityInput.value
          );

        }

        const distributionInput =
          event.target.closest(
            '[data-cart-distribution]'
          );


        if (
          distributionInput
        ) {

          updateDistributionQuantity(

            distributionInput.dataset
              .cartDistribution,

            distributionInput.dataset
              .cartDistributionOption,

            distributionInput.dataset
              .cartDistributionValue,

            distributionInput.value

          );

        }

      }
    );



    /* =======================================================
       CART UPDATE EVENT
       ======================================================= */

    window.addEventListener(
      'ecobos:cart:updated',
      function() {

        renderCart();

      }
    );


    renderCart();

  }



  /* =========================================================
     ALLE CARTS INITIALISEREN
     ========================================================= */

  function initAllEcobosCarts() {

    document
      .querySelectorAll(
        '[data-ecobos-cart]'
      )
      .forEach(
        function(root) {

          initEcobosCart(
            root
          );

        }
      );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAllEcobosCarts
    );

  }

  else {

    initAllEcobosCarts();

  }

})();